module.exports = __webpack_public_path__ + "static/media/logo_light.cb14aadc.svg";